/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Backbone from 'backbone';
import Radio from 'backbone.radio';
import Ladda from 'ladda';

// import showModal from '@/util/showModal';
import showErrorMessage from '@/util/showErrorMessage';

import UserSearchResultsCollectionView from '../UserSearchResultsCollectionView/UserSearchResultsCollectionView';
import UserDetailsView from '../UserDetailsView/UserDetailsView';
import SearchAllUsers from '../../services/SearchAllUsers';
// import UserRegistrationModal from '../UserRegistrationModal/UserRegistrationModal'

import tmplSelfServiceView from './SelfServiceView.hbs';
import './SelfServiceView.css';

const SelfServiceView = View.extend({
  template: tmplSelfServiceView,

  ui: {
    userSearchField: '#userSearchField',
    searchUserBtn: '.btn-search-user',
    // registerUserBtn: '.btn-register-user',
    userSearchResults: '.user-search-results',
    userDetails: '.user-details',
    userName: '.user-full-name',
    btnSave: '.btn-save'
  },

  regions: {
    userSearchResults: '@ui.userSearchResults',
    userDetails: '@ui.userDetails'
  },

  events: {
    // 'click @ui.registerUserBtn': 'registerNewUser',
    'click @ui.searchUserBtn': 'searchUser',
    'keypress @ui.userSearchField': 'focusOnSearchButton',
    'click @ui.btnSave': 'onSave'
  },

  initialize() {
    this.listenTo(Radio.channel('userDetails'), 'update:profile', (data, groups, edipi) => {
      const fullName = `${data.firstName} ${data.lastName}`;
      this.model.set('fullName', fullName);
      data.fullName = fullName
      this.ui.userName.text(fullName);
      this.showUserDetailsView(data, groups, edipi);
    });
  },

  onRender() {
    this.showUserSearchResultsCollectionView([]);
    this.showUserDetailsView();
    this.ui.btnSave.prop("disabled", true);
  },

  showUserSearchResultsCollectionView(results) {
    this.userSearchResults = new UserSearchResultsCollectionView({
      collection: new Backbone.Collection(results)
    });
    this.showChildView('userSearchResults', this.userSearchResults);
  },

  showUserDetailsView(profile, groups, edipi) {
    this.model.set('profile', profile)
    const model = new Backbone.Model({
      profile,
      groups,
      roles: this.model.get('roles'),
      edipi
    })
    this.userDetailsView = new UserDetailsView({ model })
    this.showChildView('userDetails', this.userDetailsView);

    if(profile) this.ui.btnSave.prop("disabled",false);
  },

  async searchUser(e) {
    const spinner = Ladda.create(this.ui.searchUserBtn[0]);
    $(this.ui.searchUserBtn[0]).removeClass('.ladda-button');
    spinner.start();

    const userName = this.ui.userSearchField.val();
    const isExternal = $(`input[name="radioIntExt"]:checked`).val();

    try{
      const searchResults = await SearchAllUsers(userName, isExternal);
      this.userSearchResults.collection.reset(searchResults.users);
    } finally {
      spinner.stop();
    }
  },

  focusOnSearchButton(e) {
    if (e.key !== 'Enter') return;
    this.ui.searchUserBtn.click();
  },

  // registerNewUser(e) {
  //   e.preventDefault();
  //   showModal({
  //     title: 'Register New User',
  //     dialogClasses: 'modal-lg',
  //     view: new UserRegistrationModal({
  //       confirmText: 'Register New User',
  //       model: new Backbone.Model()
  //     })
  //   })
  // },

  async onSave(e) {
    e?.preventDefault();
    
    const spinner = Ladda.create(this.ui.btnSave[0]);
    spinner.start();

    try {
      await this.getChildView('userDetails').onSaveUser();
    } catch (err) {
      showErrorMessage({
        errorCode: err.message.code,
        errorTitle: err.message.string,
        hideAfter: 10,
        errorMessage: err.message.detail   
      });
    } finally {
      spinner.stop();
    }
  }
});

export default SelfServiceView;
